export default __webpack_public_path__ + "static/sedan_small-cafa2edf630984cdb862dd04bdd685d2.webp";